﻿$.fn.dxCtrlConfigPopupPopImap = function custom_dxCtrlConfigPopupPopImap(option) {
    if (option == "instance") {
        return this.instance;
    }
    else {
        this.addClass("dx-dxctrlconfigpopuppopimap dx-ctrl");
        this.createInstance(new cdxCtrlConfigPopupPopImap(this, option));
    }
    return this;
}

window.cdxCtrlConfigPopupPopImap = function (container, option) {
    var Me = this;

    this.option = function (name, value) {
        if (typeof value == 'undefined') {
            return option[name];
        }
        else {
            option[name] = value;
        }
    }

    var popup = null
    var jauge = null
    var inChangeCode = false
    function mConstruit() {
        container.empty();

        popup = container.appendTo("body").dxCtrlPopupBase({
            fullScreen: false,
            showTitle: true,
            shading: true,
            showMaximize: false,
            showCloseButton: false,
            width: 600,
            height: "auto",
            title: "Configuration Réception",
            onShown: function (e) { dxCtrlTxtLogin.focus() },
            contentTemplate: function (contentElement) {
                contentElement.css("padding-top", "0")
                mRempli(contentElement)
            }
        }).dxCtrlPopupBase("instance")
        popup.show()
    }

    var isConfigValide = false
    var dxCtrlTxtLogin = null
    var dxCtrlTxtPwd = null
    var dxCtrlTxtServeur = null
    var dxCtrlTxtPort = null
    var dxCtrlSwitchImapPop = null
    var dxCtrlSwitchSsl = null
    function mRempli(contentElement) {

        jauge = $("<div/>").appendTo(contentElement).dxCtrlJauge({}).dxCtrlJauge("instance")

        var items = [];
        items.push({
            label: { visible: false, text: "serveur", location: "left" },
            template: function (itemData, itemElement) {
                var dxBtReinit = $("<div/>").appendTo(itemElement).dxCtrlButton({
                    width: "100%",
                    txtTooltip: "Réinitialise le serveur,<br/>son type, le port et le mode (ssl)<br/>sur la base des configurations trouvées sur internet",
                    text: "Réinitialiser paramètres par défaut",
                    onClick: function (e) {
                        jauge.mShow()
                        jauge.option("message", "Recherche des configurations")
                        mGetConfigMail(option.bddCtrl, option.value.adresse_email, function (dataConfig) {
                            if (dataConfig != null && typeof dataConfig.reception_serveur != 'undefined') {
                                dxCtrlTxtServeur.option("value", dataConfig.reception_serveur)
                                dxCtrlTxtPort.option("value", dataConfig.reception_port)
                                dxCtrlSwitchSsl.option("value", (dataConfig.reception_ssl == "1"))
                                dxCtrlSwitchImapPop.option("value", (dataConfig.reception_is_imap == "1"))
                                mNotify("Les paramètres ont été réinitialisé", "success", 6000)
                            } else {
                                mNotify("Aucun paramètres trouvé", "error", 6000)
                            }
                            jauge.mHide()
                        })
                    }
                }).dxCtrlButton("instance")
            },
            colSpanXs: 16, colSpanSm: 16, colSpanMd: 16, colSpanLg: 16
        })
        items.push({
            label: { visible: false, text: "login", location: "left" },
            template: function (itemData, itemElement) {
                dxCtrlTxtLogin = $("<div/>").appendTo(itemElement).dxCtrlTextBox({
                    label: "Login pour se connecter",
                    labelMode: 'floating',
                    placeholder: "Le login correspond, en général, à votre adresse email...",
                    value: option.value.reception_login,
                    onValueChanged: function (e) {
                        isConfigValide = false
                    }
                }).dxCtrlTextBox("instance")
            },
            colSpanXs: 16, colSpanSm: 16, colSpanMd: 16, colSpanLg: 16
        })
        items.push({
            label: { visible: false, text: "pwd", location: "left" },
            template: function (itemData, itemElement) {
                dxCtrlTxtPwd = $("<div/>").appendTo(itemElement).dxCtrlTextBox({
                    label: "Mot de passe",
                    labelMode: 'floating',
                    placeholder: "...",
                    buttons: [{
                        focusStateEnabled: false,
                        name: 'showpwd',
                        location: 'after',
                        options: {
                            icon: 'eyeopen',
                            hint: "Révéler/cacher le texte",
                            focusStateEnabled: false,
                            stylingMode: 'text',
                            onClick() {
                                if (dxCtrlTxtPwd.element().find("input").hasClass("txtPassword")) {
                                    if (dxCtrlTxtPwd.option("value") != null && dxCtrlTxtPwd.option("value").contains("xxxxx")) {
                                        //Le mot de passe est en mémoire et ne peut être révélé
                                        dxCtrlTxtPwd.option("value", "")
                                        mNotify("Le mot de passe en mémoire ne peut être révélé.<br/>Celui-ci a été retiré.<br/>Vous pouvez maintenant saisir votre nouveau mot de passe", "warning", 6000)
                                    }
                                    dxCtrlTxtPwd.element().find("input").removeClass("txtPassword")
                                } else {
                                    dxCtrlTxtPwd.element().find("input").addClass("txtPassword")
                                }
                            },
                        },
                    }],
                    value: option.value.reception_pwd,
                    onValueChanged: function (e) {
                        if (inChangeCode) return
                        isConfigValide = false
                        hasPasswordSaisie = true
                    },
                    onContentReady: function (e) {
                        e.component.element().find("input").addClass("txtPassword")
                    }
                }).dxCtrlTextBox("instance")

                if (typeof option.value.reception_pwd != 'undefined' && option.value.reception_pwd != null && option.value.reception_pwd.length > 0) {
                    hasPasswordSaisie = true
                } else {
                    var inChangeCode = false
                    option.bddCtrl.mAjaxCall({
                        command: "hasemailpwd",
                        adresse_email: option.value.adresse_email
                    }, function (data) {
                        hasPassword = (data.nbcar_reception_pwd > 0)
                        if (hasPassword) {
                            var txt = ""
                            for (var i = 0; i < parseInt(data.nbcar_reception_pwd); i++) { txt += "x" }
                            inChangeCode = true;
                            dxCtrlTxtPwd.option("value", txt)
                            inChangeCode = false
                        }
                    });
                }

            },
            colSpanXs: 16, colSpanSm: 16, colSpanMd: 16, colSpanLg: 16
        })
        items.push({
            label: { visible: false, text: "serveur", location: "left" },
            template: function (itemData, itemElement) {
                var $Table = $("<table style='width:100%'/>").appendTo(itemElement)
                var $Tr = $("<tr/>").appendTo($Table)
                var $Td = $("<td style='width:100%;vertical-align:middle;'/>").appendTo($Tr)
                dxCtrlTxtServeur = $("<div/>").appendTo($Td).dxCtrlTextBox({
                    label: "Nom du serveur",
                    labelMode: 'floating',
                    placeholder: "...",
                    value: option.value.reception_serveur,
                    onValueChanged: function (e) {
                        isConfigValide = false
                    }
                }).dxCtrlTextBox("instance")

                var $Td = $("<td style='width:1px;white-space:nowrap;padding-left:10px;text-align:right;'>Type<br/>serveur:</td>").appendTo($Tr)
                var $Td = $("<td style='width:1px;vertical-align:middle;padding-left:10px;'/>").appendTo($Tr)
                dxCtrlSwitchImapPop = $("<div/>").appendTo($Td).dxCtrlSwitch({
                    width: 60,
                    switchedOffText: "POP",
                    switchedOnText: "IMAP",
                    value: (option.value.reception_is_imap == "1"),
                    focusStateEnabled: false,
                    onValueChanged: function (e) {
                        isConfigValide = false
                    }
                }).dxCtrlSwitch("instance")
            },
            colSpanXs: 16, colSpanSm: 16, colSpanMd: 16, colSpanLg: 16
        })
        items.push({
            label: { visible: false, text: "serveur", location: "left" },
            template: function (itemData, itemElement) {
                var $Table = $("<table style='width:100%'/>").appendTo(itemElement)
                var $Tr = $("<tr/>").appendTo($Table)
                var $Td = $("<td style='width:100%;'></td>").appendTo($Tr)
                dxCtrlTxtPort = $("<div style='width:100%'/>").appendTo($Td).dxCtrlNumberBox({
                    label: "Port du serveur",
                    labelMode: 'floating',
                    //placeholder: "...",
                    value: option.value.reception_port,
                    width: "100%",
                    onValueChanged: function (e) {
                        isConfigValide = false
                    }
                }).dxCtrlNumberBox("instance")
                var $Td = $("<td style='width:1px;white-space:nowrap;padding-left:10px;'>SSL/TLS:</td>").appendTo($Tr)
                var $Td = $("<td style='width:1px;padding-left:10px;vertical-align:middle;'/>").appendTo($Tr)
                dxCtrlSwitchSsl = $("<div/>").appendTo($Td).dxCtrlSwitch({
                    width: 50,
                    value: (option.value.reception_ssl == "1"),
                    focusStateEnabled: false,
                    onValueChanged: function (e) {
                        isConfigValide = false
                    }
                }).dxCtrlSwitch("instance")
            },
            colSpanXs: 16, colSpanSm: 16, colSpanMd: 16, colSpanLg: 16
        })
        items.push({
            label: { visible: false, text: "login", location: "left" },
            template: function (itemData, itemElement) {
                itemElement.css("text-align", "right")
                dxBtTest = $("<div style='display:inline-block;'/>").appendTo(itemElement).dxCtrlButton({
                    text: "Tester les paramètres",
                    onClick: function (e) {
                        Me.mTestConnexionImapPop(null, null, resultBtOkAnnuler.btPlus1)
                    }
                }).dxCtrlButton("instance")
            },
            colSpanXs: 16, colSpanSm: 16, colSpanMd: 16, colSpanLg: 16
        })

        var $DivForm = $("<div style='position:relative;'/>").appendTo(contentElement)
        var form = $("<div style='padding:0 65px 20px 65px;'/>").appendTo($DivForm).dxCtrlForm({
            labelMode: 'floating',
            showColonAfterLabel: true,
            labelLocation: 'left',
            items: items
        }).dxCtrlForm("instance");

        var resultBtOkAnnuler = mAddButtonOkAnnuler(contentElement,
            function () { //ok
                if (!isConfigValide) {
                    Me.mTestConnexionImapPop(function () {
                        option.onValide(option.value)
                        popup.hide()
                    }, function () {
                    }, resultBtOkAnnuler.btPlus1)
                } else {
                    option.onValide(option.value)
                    popup.hide()
                }
            },
            function () { //annuler
                if (typeof option.onCancel != 'undefined') option.onCancel()
                popup.hide();
            }, null, "Valider",
            function () {
                $("<div/>").appendTo("body").dxCtrlDemandeConfigGmail({
                    bddCtrl: option.bddCtrl,
                    adresseEmail: option.value.adresse_email,
                    onValidPwd: function (opt) {
                        //pop.gmail.com / 995 / SSL ON
                        dxCtrlTxtLogin.option("value",opt.adresse_email)
                        dxCtrlSwitchImapPop.option("value", opt.pop_switch)
                        dxCtrlTxtServeur.option("value", opt.pop_serveur)
                        dxCtrlTxtPort.option("value", opt.pop_port)
                        dxCtrlSwitchSsl.option("value", opt.pop_ssl)
                        dxCtrlTxtPwd.option("value", opt.pwd_app)

                        mNotify("La configuration est maintenant remplie. Vous n'avez plus qu'à la valider.", "success", 6000)
                    },
                    onDemandeConnexionOauthGmail: function () {
                        popup.hide()
                        option.onDemandeConnexionOauthGmail()
                    },
                    onDemandeClosePopupParent: function () {
                        popup.hide()
                        option.onDemandeClosePopupParent()
                    }
                })
                //mCreateTokenEmailGmail({
                //    bddCtrl: option.bddCtrl,
                //    onStart: function () { },
                //    onValide: function (dataCompteEmail, dataCompteEmailUtilisateur) {
                //        option.onValide(option.value)
                //        popup.hide()
                //    }
                //})
            }, "Gmail, iCloud, Aol, Yahoo...")
    }

    var hasPasswordSaisie = false
    this.mTestConnexionImapPop = function (funcOk, funcKo,btnGmail) {
        debugger; //2 (a partir popup de config popimap avec bouton gmail)
        isConfigValide = false
        dxCtrlTxtLogin.element().css("border", "")
        dxCtrlTxtPwd.element().css("border", "")
        dxCtrlTxtServeur.element().css("border", "")
        dxCtrlTxtPort.element().css("border", "")
        dxCtrlSwitchSsl.element().css("border", "")
        dxCtrlSwitchImapPop.element().css("border", "")
        var txt = ""
        if (dxCtrlTxtLogin.option("value") == null || dxCtrlTxtLogin.option("value").length == 0) {
            dxCtrlTxtLogin.element().css("border", "1px solid " + theme.toastError)
            dxCtrlTxtLogin.focus()
            txt += ((txt.length > 0) ? "<br/>" : "") + "&bull; Vous devez saisir le login"
        }
        if (dxCtrlTxtPwd.option("value") == null || dxCtrlTxtPwd.option("value").length == 0) {
            dxCtrlTxtPwd.element().css("border", "1px solid " + theme.toastError)
            dxCtrlTxtPwd.focus()
            txt += ((txt.length > 0) ? "<br/>" : "") + "&bull; Vous devez saisir le mot de passe"
        }
        if (dxCtrlTxtServeur.option("value") == null || dxCtrlTxtServeur.option("value").length == 0) {
            dxCtrlTxtServeur.element().css("border", "1px solid " + theme.toastError)
            dxCtrlTxtServeur.focus()
            txt += ((txt.length > 0) ? "<br/>" : "") + "&bull; Vous devez saisir l'adresse du serveur"
        }
        if (dxCtrlTxtPort.option("value") == null || dxCtrlTxtPort.option("value") == 0) {
            dxCtrlTxtPort.element().css("border", "1px solid " + theme.toastError)
            dxCtrlTxtPort.focus()
            txt += ((txt.length > 0) ? "<br/>" : "") + "&bull; Vous devez saisir le port du serveur"
        }
        if (txt.length > 0) {
            txt = "Impossible de tester votre configuration, des informations sont manquantes:<br/>" + txt
            mNotify(txt, "error", 12000)
            if (typeof funcKo != 'undefined' && funcKo!=null) funcKo()
        } else {
            jauge.mShow()
            jauge.option("message", "Vérification de vos paramètres de réception")
            jauge.option("onCancel", function () {
                reqAjax.abort()
                if (typeof option.onErreurTestConnexion != 'undefined') option.onErreurTestConnexion()
            })
            var reqAjax = option.bddCtrl.mAjaxCall({
                command: ((dxCtrlSwitchImapPop.option("value")) ? "testemailimap" : "testemailpop"),
                server: dxCtrlTxtServeur.option("value"),
                port: dxCtrlTxtPort.option("value"),
                ssl: ((dxCtrlSwitchSsl.option("value")) ? "1" : "0"),
                login: dxCtrlTxtLogin.option("value"),
                adresse_email: option.value.adresse_email,
                pwd: dxCtrlTxtPwd.option("value"),
                utilise_pwd_bdd: ((hasPasswordSaisie) ? "0" : "1")
            }, function (data) {
                if (typeof data.message_erreur != 'undefined') {
                    var txt = ""
                    isConfigValide = false
                    dxCtrlTxtLogin.element().css("border", "1px solid " + theme.toastError)
                    dxCtrlTxtPwd.element().css("border", "1px solid " + theme.toastError)
                    var txt = ""
                    if (!data.message_erreur.contains("(1265)")) {
                        dxCtrlTxtServeur.element().css("border", "1px solid " + theme.toastError)
                        dxCtrlTxtPort.element().css("border", "1px solid " + theme.toastError)
                        dxCtrlSwitchSsl.element().css("border", "1px solid " + theme.toastError)
                        dxCtrlSwitchImapPop.element().css("border", "1px solid " + theme.toastError)
                        txt = "<br/>Si vous ne connaissez pas la configuration de votre adresse email, demander à votre hébergeur les paramètres du POP/IMAP de votre adresse email."
                    }
                    txt = "Les paramètres de connexion que vous avez saisie sont incorrecte:<br/>" + "&bull; " + data.message_erreur.replace(" (1265)", "") + txt
                    if ((typeof option.value.reception_serveur != 'undefined' && option.value.reception_serveur && option.value.reception_serveur.endsWith(".gmail.com")) || option.value.adresse_email.endsWith("@gmail.com")) {
                        window.funcBtnGmail = function () { btnGmail.performClick(); }
                        txt += "<br/><br/><b><a href='#' onClick='funcBtnGmail();return false;' target='_blank' style='color:white' class='blink'>Pour GMAIL, vous devez intervenir sur votre compte pour créer un mot de passe d'application. cliquer pour en savoir plus.</a></b>"
                    }
                    mNotify(txt, "error", 20000)
                    if (typeof funcKo != 'undefined' && funcKo !=null) funcKo()
                }
                else {
                    isConfigValide = true
                    option.value.reception_login = dxCtrlTxtLogin.option("value")
                    option.value.reception_serveur = dxCtrlTxtServeur.option("value")
                    option.value.reception_port = dxCtrlTxtPort.option("value")
                    option.value.reception_ssl = ((dxCtrlSwitchSsl.option("value")) ? "1" : "0")
                    option.value.reception_is_imap = ((dxCtrlSwitchImapPop.option("value")) ? "1" : "0")
                    if (hasPasswordSaisie) { option.value.reception_pwd = dxCtrlTxtPwd.option("value") }
                    mNotify("La configuration que vous avez saisie est correcte", "success", 12000)
                    if (typeof funcOk != 'undefined' && funcOk != null) funcOk()
                }
                jauge.mHide()
                jauge.option("message", null)
                jauge.option("onCancel", null)
            }, function () {
                jauge.mHide()
                jauge.option("message", null)
                jauge.option("onCancel", null)
            });
        }
    }

    this.element = function () { return container }

    mConstruit();
}